module.exports = __webpack_public_path__ + "imgs/leafwell-logo.258f51a7082b0fc2466f6cd70f049bd2.svg";